import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function BillingCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-amber-50 to-white p-6">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 text-center space-y-4">
          <div className="w-16 h-16 mx-auto bg-amber-100 rounded-full flex items-center justify-center">
            <XCircle className="w-8 h-8 text-amber-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900">Payment Cancelled</h1>
          <p className="text-slate-600">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          <div className="flex gap-3 justify-center pt-4">
            <Button variant="outline" onClick={() => navigate("/dashboard")}>
              Go to Dashboard
            </Button>
            <Button onClick={() => navigate("/dashboard/billing")}>
              Try Again
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
